module.exports = __webpack_public_path__ + "img/icon-sleep-time-1.9ba255da.svg";